import Q from 'q';
import request from './Request';
import qs from 'qs';
import objectAssignDeep from 'object-assign-deep';
import _ from 'underscore';

let instances = {};

class Collection {

	constructor() {
		this.arguments = {};
		this.endpoint = '';
		this.model = '';
		this.idPool = [];
		this.modelCache = {};
		this.processingIDPool = false;
		setInterval(this.fetchIDPool.bind(this), 250);
	}

	static className() {
		return 'Collection';
	}

	static getInstance() {
		var class_name = this.className();
		if (typeof(instances[class_name]) === 'undefined') {
			instances[class_name] = new this();
		}
		return instances[class_name];
	}

	fetchIDPool() {

		var self = this;

		// Make sure the ID pool actually has items in it.
		if (this.idPool.length <= 0 || this.processingIDPool) { return; }
		this.processingIDPool = true;

		// Get the IDs that don't already exist in the model cache.
		var allResultsWithCache = [];
		var newIDPool = objectAssignDeep({}, this.idPool);
		_.each(this.idPool, function (idPoolItem) {
			if (typeof(self.modelCache[idPoolItem.id]) !== 'undefined') {
				allResultsWithCache.push(self.modelCache[idPoolItem.id]);
				newIDPool = _.without(newIDPool, idPoolItem);
			}
		});

		// Generate the new arguments with the IDs.
		var args = {
			parameters: {
				'id.in': _.pluck(newIDPool, 'id')
			}
		};

		// Make the request and get the promise response.
		this.fetch(args).then(function (serverResults) {
			var allResults = serverResults.concat(allResultsWithCache);
			_.each(allResults, function (result) {
				var idItem = _.findWhere(self.idPool, { id: result.id });
				if (idItem && idItem.resolveCallback) {
					idItem.resolveCallback([result]);
					self.idPool = _.without(self.idPool, idItem);
				}
			});
		}, function (error) {
			_.each(self.idPool, function (item) {
				item.rejectCallback(error);
			});
			self.idPool = [];
		}).fin(function () {
			self.processingIDPool = false;
		}).done();

	}

	fetch(args, useDefault = true) {
		var self = this;
		return Q.Promise(function (resolve, reject, notify) {

			var requestArguments = args;

			// Add the default arguments for the current class.
			if (useDefault) {

				// Add the model's fields as an argument.
				var defaultArguments = objectAssignDeep({}, self.arguments);
				defaultArguments.fields = self.model.fields();

				requestArguments = objectAssignDeep(defaultArguments, args);

			}

			// Alter the fields request if it's an array.
			if (Array.isArray(requestArguments.fields)) {
				requestArguments.fields = requestArguments.fields.join(',');
			}

			// If we're looking for an ID, add it to the current ID pool
			// and set a timeout to fetch the pending IDs.
			if (requestArguments.parameters && requestArguments.parameters.id) {

				// If the item is in the model cache, automatically resolve.
				if (typeof(self.modelCache[requestArguments.parameters.id]) !== 'undefined') {
					resolve([self.modelCache[requestArguments.parameters.id]]);
					return;
				}

				// Otherwise, add it to the ID pool to be fetched.
				self.idPool.push({
					id: requestArguments.parameters.id,
					resolveCallback: resolve,
					rejectCallback: reject
				});
				return;

			}

			// Make the HTTP request to the server to fetch the information.
			request.get(self.endpoint)
				.query(qs.stringify(requestArguments, { encode: false }))
				.set('Accept', 'application/json')
				.end(function (err, res) {
					if (res.status === 200 && !err) {
						var results = [];
						var promises = [];
						var index = 0;
						res.body.forEach(function (result) {

							// We have to clone the result object so that any modifications
							// to it done underneath the model aren't stored in the LocalStorage
							// cache in the production environment.
							(function (index, data) {
								promises.push(self.model.parse(data)
									.then(function (result) {
										results[index] = result;
										self.modelCache[result.id] = result;
									}));
							})(index, objectAssignDeep({}, result));
							index++;

						});
						Q.all(promises).then(function () {
							resolve(results);
						}).fail(reject).done();
					} else {
						reject(err, res);
					}
				});

		});
	}

}

export default Collection;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/common/Collection.js
 **/